import Vue from 'vue';
import { ValidationProvider, ValidationObserver, extend, configure } from 'vee-validate';
import { required, min, email } from 'vee-validate/dist/rules';
import isCreditCard from 'validator/lib/isCreditCard';
import isPhone from 'validator/lib/isMobilePhone';
import _ from 'lodash';
import lsCycleFilter from '@/filters/ls-cycle.filter';
import lsDateFilter from '@/filters/ls-date.filter';
import lsMoneyFilter from '@/filters/ls-money.filter';
import lsServiceNameFilter from '@/filters/ls-service-name.filter';

Vue.filter('lsCycle', lsCycleFilter);
Vue.filter('lsDate', lsDateFilter);
Vue.filter('lsMoney', lsMoneyFilter);
Vue.filter('lsServiceName', lsServiceNameFilter);

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
configure({
    classes: {
        invalid: 'ls-invalid',
    },
});
extend('required', required);
extend('min', min);
extend('email', email);
extend('isNotDuplicateEmail', {
    params: ['duplicateEmail'],
    validate(value, { duplicateEmail }) {
        return _.toUpper(value) !== _.toUpper(duplicateEmail);
    },
});
extend('hasPlaceId', {
    params: ['address'],
    validate(value, { address }) {
        return !!address.googlePlace.place_id;
    },
});
extend('hasStreetNumber', {
    params: ['address'],
    validate(value, { address }) {
        return !!address.googlePlace.street_number || !!address.manualStreetNumber;
    },
});
extend('isCreditCard', isCreditCard);
extend('isPhone', {
    validate(value) {
        const nonNumberRegex = /[^0-9]+/g;
        const numbersOnly = _.replace(`${value}`, nonNumberRegex, '');
        return isPhone(numbersOnly, 'en-US');
    },
});
